module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog', {
    ref: "sendSummaryDialog"
  }, [_c('md-dialog-title', [_vm._v("Skriv inn e-post til mottaker")]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('email')
    }
  }, [_c('label', [_vm._v("E-post")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    model: {
      value: (_vm.prompt.email),
      callback: function($$v) {
        _vm.$set(_vm.prompt, "email", $$v)
      },
      expression: "prompt.email"
    }
  }), _vm._v(" "), (_vm.errors.hasError('email')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('email')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    attrs: {
      "disabled": _vm.state.is('sending')
    },
    on: {
      "click": function($event) {
        _vm.closeDialog('sendSummaryDialog')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    attrs: {
      "disabled": _vm.state.is('sending')
    },
    on: {
      "click": function($event) {
        _vm.sendNotification()
      }
    }
  }, [(_vm.state.is('sending')) ? _c('span', [_vm._v("Sender...")]) : _c('span', [_vm._v("Send")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v("Ordredetaljer")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb3"
  }, [_vm._v("\n    Her finner du en detaljert overiskt over din ordre. Du kan også håndtere filene for ordren her.")]), _vm._v(" "), (_vm.order) ? _c('div', [_c('div', {
    staticClass: "clearfix mxn2"
  }, [_c('div', {
    staticClass: "col col-4 px2"
  }, [_c('div', {
    staticClass: "card sh1 rounded p3 mb3"
  }, [_c('div', [_c('div', {
    staticClass: "fz24 light mb2"
  }, [_vm._v("Detaljer")]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('div', {
    staticClass: "fz12"
  }, [_vm._v("Navn på bestilling")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('div', {
    staticClass: "fz12"
  }, [_vm._v("Navn/firma (kunde)")]), _vm._v(" "), (_vm.order.data.client.name) ? _c('div', [_vm._v(_vm._s(_vm.order.data.client.name))]) : _c('div', {
    staticClass: "italic"
  }, [_vm._v("Ikke oppgitt...")])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('div', {
    staticClass: "fz12"
  }, [_vm._v("E-post (kunde)")]), _vm._v(" "), (_vm.order.data.client.email) ? _c('div', [_vm._v(_vm._s(_vm.order.data.client.email))]) : _c('div', {
    staticClass: "italic"
  }, [_vm._v("Ikke oppgitt...")])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('div', {
    staticClass: "fz12"
  }, [_vm._v("Plassert")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.toLocaleDate(_vm.order.created_at.time)))])])]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('div', {
    staticClass: "fz24 light mb2"
  }, [_vm._v("Merknader")]), _vm._v(" "), (_vm.order.notes) ? _c('pre', {
    staticClass: "bg-light-grey p3 rounded"
  }, [_vm._v(_vm._s(_vm.order.notes))]) : _c('pre', {
    staticClass: "bg-light-grey p3 rounded"
  }, [_vm._v("Ingen merknader...")])]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('div', {
    staticClass: "fz24 light mb2"
  }, [_vm._v("Ordrebekreftelse")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary btn-block",
    nativeOn: {
      "click": function($event) {
        _vm.downloadOrder()
      }
    }
  }, [_c('md-icon', {
    staticClass: "mr1"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('span', [_vm._v("Last ned som PDF")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card sh1 rounded p3"
  }, [_c('div', {
    staticClass: "fz24 light mb2"
  }, [_vm._v("Leveringsadresse")]), _vm._v(" "), (_vm.order.data.delivery_address) ? _c('div', [_c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Navn")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.data.delivery_address.name))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Adresse")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.data.delivery_address.address))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Postnummer")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.data.delivery_address.zip))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Poststed")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.data.delivery_address.city))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col col-8 px2"
  }, [_c('div', {
    staticClass: "card sh1 rounded p3 relative"
  }, [(_vm.state.is('working')) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fz24 light"
  }, [_vm._v("Behandle filer")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("\n            Last opp trykklare filer ordren.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("\n            Om du ønsker å bestille flere varianter av et produkt (f.eks. beachflagg med to forskjellige motiver) kan du legge til flere filer på produktet.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "fz16 bold mb2 mt3"
  }, [_vm._v("Trykkfiler for produkter:")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix relative"
  }, [(_vm.order.lines.length > 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.order.lines), function(orderLine, index) {
    return _c('tbody', [_c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "p3 border-bottom border-light-grey"
    }, [_c('div', {
      staticClass: "fz24 light mb1"
    }, [_vm._v(_vm._s(orderLine.product.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(orderLine.parameters_text))])]), _vm._v(" "), _c('td', {
      staticClass: "border-bottom border-light-grey center"
    }, [_vm._v("\n                    " + _vm._s(orderLine.quantity) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "border-bottom border-light-grey cell-actions center"
    }, [_c('md-button', {
      staticClass: "md-icon-button text-blue",
      attrs: {
        "type": "file"
      },
      nativeOn: {
        "click": function($event) {
          _vm.pickFile(orderLine.id, 'order_line')
        }
      }
    }, [_c('md-tooltip', [_vm._v("Last opp ny trykkfil")]), _vm._v(" "), _c('md-icon', [_vm._v("file_upload")])], 1), _vm._v(" "), _c('div', {
      staticClass: "hiddenfile"
    }, [_c('input', {
      attrs: {
        "type": "file",
        "id": 'file_order_line_' + orderLine.id
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, orderLine.id, 'order_line')
        }
      }
    })])], 1)]), _vm._v(" "), _vm._l((orderLine.attachments), function(attachment, attIndex) {
      return _c('tr', [_c('td', {
        staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey",
        attrs: {
          "colspan": "2"
        }
      }, [_c('div', {
        staticClass: "bold mb1"
      }, [_vm._v("Vedlegg " + _vm._s(attIndex + 1) + ":")]), _vm._v(" "), _c('a', {
        attrs: {
          "href": attachment.artworks[0].href,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(attachment.artworks[0].original_filename))])]), _vm._v(" "), _c('td', {
        staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey"
      }, [_c('md-button', {
        staticClass: "md-icon-button text-grey",
        attrs: {
          "type": "file"
        },
        nativeOn: {
          "click": function($event) {
            _vm.deleteAttachment(index, attachment.id, 'order_line')
          }
        }
      }, [_c('md-tooltip', [_vm._v("Slett vedlegg")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)])
    })], 2)
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fz16 bold mb2 mt3"
  }, [_vm._v("Andre filer:")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix relative"
  }, [(_vm.order.lines.length > 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.order.attachments), function(attachment, attIndex) {
    return _c('tr', [_c('td', {
      staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey"
    }, [_c('div', {
      staticClass: "bold mb1"
    }, [_vm._v("Vedlegg " + _vm._s(attIndex + 1) + ":")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": attachment.artworks[0].href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(attachment.artworks[0].original_filename))])]), _vm._v(" "), _c('td', {
      staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey center"
    }, [_c('md-button', {
      staticClass: "md-icon-button text-grey",
      attrs: {
        "type": "file"
      },
      nativeOn: {
        "click": function($event) {
          _vm.deleteAttachment(attIndex, attachment.id, 'order')
        }
      }
    }, [_c('md-tooltip', [_vm._v("Slett vedlegg")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey"
  }, [_c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.pickFile(_vm.order.id, 'order')
      }
    }
  }, [_vm._v("\n                      Last opp ny fil\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "hiddenfile"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": 'file_order_' + _vm.order.id
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.order.id, 'order')
      }
    }
  })])], 1), _vm._v(" "), _c('td', {
    staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey center"
  })])], 2)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card sh1 rounded p3 mt3 pb4"
  }, [_c('div', {
    staticClass: "fz24 light"
  }, [_vm._v("Ordreoversikt")]), _vm._v(" "), _c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.order.lines), function(orderLine, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "cell-image p2"
    }, [_c('img', {
      staticClass: "rounded pointer",
      attrs: {
        "src": _vm.getThumbnail(orderLine.product),
        "width": "80",
        "height": "80"
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz18 mb1"
    }, [_vm._v(_vm._s(orderLine.product.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(orderLine.parameters_text))])]), _vm._v(" "), _c('td', {
      staticClass: "center px3"
    }, [_vm._v("\n                " + _vm._s(orderLine.quantity) + "\n              ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-grey truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(orderLine.unit_price / 100)) + ",-")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-blue truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(orderLine.total / 100)) + ",-")])])])
  }))]), _vm._v(" "), _c('table', {
    staticClass: "full-width"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "border-top border-light-grey",
    staticStyle: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-grey pt3 truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.order.net_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("Total eksl. MVA")])]), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-grey pt3 truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.order.vat_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("MVA")])]), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey pt3"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-blue truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.order.gross_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("Total inkl. MVA")])])])])])])])])]) : _c('div', {
    staticClass: "p3 center"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey px3 py2 light left-align"
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Antall")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Handlinger")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey px3 py2 light left-align"
  }, [_vm._v("Fil")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Handlinger")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey "
  }), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Antall")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Pris pr. stk.")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align",
    attrs: {
      "light": ""
    }
  }, [_vm._v("Total")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2346049a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/shop/ViewOrder.vue
// module id = 637
// module chunks = 1